import { Routes } from '@angular/router';
import { LandingComponent } from './features/landing/landing.component';
import { RegistrationComponent } from './features/registration/registration.component';
import { LoginComponent } from './features/login/login.component';
import { VerificationComponent } from './features/verification/verification.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { AuthGuard } from './core/guards/auth.guard';
import { UploadStatementComponent } from './features/statements/upload-statement.component';
import { StatementsListComponent } from './features/statements/statements-list.component';
import { StatementDetailComponent } from './features/statements/statement-detail.component';
import { ReconciliationRunDetailComponent } from './features/statements/reconciliation-run-detail.component';

export const routes: Routes = [
  { path: '', component: LandingComponent },
  { path: 'register', component: RegistrationComponent },
  { path: 'verify/:id/:code', component: VerificationComponent },
  { path: 'login', component: LoginComponent },

  { path: 'app', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'app/upload', component: UploadStatementComponent, canActivate: [AuthGuard] },
  { path: 'app/statements', component: StatementsListComponent, canActivate: [AuthGuard] },
  { path: 'app/statements/:id', component: StatementDetailComponent, canActivate: [AuthGuard] },
  {
    path: 'app/statements/:statementId/reconciliation/runs/:runId',
    component: ReconciliationRunDetailComponent,
    canActivate: [AuthGuard]
  },

  { path: '**', redirectTo: '' }
];
